/**
 * @description
 * 常量storage的Key
 */
// 新版查单词历史记录
export const LOOK_UP_WORD_HISTORY = 'NEWLOOKUPWORDHISTORY';

// 单词 气泡 首次展示
export const FIRST_LOOK_UP_WORLD_POP = 'FIRSTLOOKUPWORLDPOP';

// 整本上传选择图书版本
export const WHOLE_BOOK_UPLOAD_BOOK_EDITION = 'WHOLEBOOKUPLOADBOOKEDITION';

// 记录上传解析首次点击解析上传图片
export const WHOLE_BOOK_UPLOAD_IS_FIRST_CLICK = 'WHOLEBOOKUPLOADISFIRSTCLICK';

// 个人已上传指定isbn教材列表
export const ISBN_UPLOAD_LIST = 'ISBNUPLOADLIST';

// 我的设置  收获地址详情
export const ADDRESS_DETAIL = 'ADDRESSDETAIL';

// feed详情统计页面停留时长
export const FEED_COLLECT_TIME_LONG = 'FEEDCOLLECTTIMELONG';

// calculator计算器页面提示示例是否展示
export const CALCULATOR_SHOW_EXAMPLE_TIP = ' CALCULATORSHOWEXAMPLETIP';

// 英语作文历史记录
export const ENGLISH_COMPOSITION_HISTORY = 'ENGLISHCOMPOSITIONHISTORY';

// 校园大使 首次进入页面
export const CAMPUS_AMBASSADOR_FIRST_ENTER = 'CAMPUSAMBASSADORFIRSTENTER';

// 电池栏高度
export const STATUS_BAR_HEIGHT = 'STATUSBARHEIGHT';
